
  <h1 mat-dialog-title>{{ data.title}}</h1>
  <mat-dialog-content [innerHtml]="data.guts" class="shmoo">
  <!-- (( this.trimLeadingTrailingQuotes(data.guts) )) -->
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>    
  